'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_s_util_Try() {
}
export { $c_s_util_Try as $c_s_util_Try };
$p = $c_s_util_Try.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_s_util_Try;
/** @constructor */
function $h_s_util_Try() {
}
export { $h_s_util_Try as $h_s_util_Try };
$h_s_util_Try.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
